import { useState } from 'react';
import { X, Search } from 'lucide-react';

const tipoUbicacionOptions = [
  { codigo: 'A', nombre: 'Lugar designado' },
  { codigo: 'B', nombre: 'Lugar autorizado' },
  { codigo: 'C', nombre: 'Lugar aprobado' },
  { codigo: 'D', nombre: 'Otros' },
];

export function getTipoUbicacionOptions() {
  return tipoUbicacionOptions;
}

export const TipoUbicacionModal = ({
  tipos = [],
  isOpen,
  onClose,
  onSelect,
  selectedTipo,
  title = 'Seleccionar Tipo de Ubicación',
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredTipos = (tipos.length ? tipos : tipoUbicacionOptions).filter((tipo) =>
    tipo.nombre.toLowerCase().includes(searchQuery.toLowerCase()) ||
    tipo.codigo.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{title}</h2>
          <button
            onClick={() => {
              setSearchQuery('');
              onClose();
            }}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="flex gap-2 mb-4">
          {/* Search Input */}
          <div className="relative flex items-center gap-2 border-container rounded-full px-3 py-1 flex-1 flex-row">
            <div className="flex-0 pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              className="pr-4 py-2 !border-none no-border search-input"
              style={{ borderWidth: '0px !important', border: '0px !important' }}
              placeholder="Buscar tipo..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="max-h-[40vh] min-h-[20vh] overflow-y-auto">
          {filteredTipos.length > 0 ? (
            <div className="space-y-0">
              {filteredTipos.map((tipo) => (
                <div
                  key={tipo.codigo}
                  className={`p-3 px-0 hover:bg-gray-100 cursor-pointer border-bottom-gray ${
                    selectedTipo && selectedTipo.codigo === tipo.codigo ? 'bg-gray-100 font-bold' : ''
                  }`}
                  onClick={() => {
                    onSelect(tipo);
                    setSearchQuery('');
                    onClose();
                  }}
                >
                  <div className="flex justify-between items-start gap-2">
                    <div>
                      <p className="font-medium">{tipo.nombre}</p>
                      <p className="text-xs text-gray-500">{tipo.codigo}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4 text-gray-500">
              No se encontraron tipos para "{searchQuery}"
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 